<div class="input-group">
  <input
    #searchBox
    type="text"
    class="form-control {{ props.cssClass }}"
    [formlyAttributes]="field"
    [formControl]="formControl"
    (keyup.enter)="search()"
  />
  <button type="button" class="btn btn-light" (click)="clearSearch(searchBox)">
    <i class="fa fa-times"></i>
  </button>
  @if (props.editButton) {
    <button type="button" class="btn btn-light" (click)="edit($event)">
      <i class="fa fa-pen"></i>
    </button>
  }
  <button type="button" class="btn btn-light" (click)="search()">
    <i class="fa fa-search"></i>
  </button>
  @if (props.advancedSearchTooltip) {
    <button
      i18n-popoverTitle
      type="button"
      class="btn btn-light"
      placement="bottom"
      popoverTitle="Advanced Search"
      [ngbPopover]="popoverContent"
    >
      <i class="fa fa-question"></i>
    </button>
    <ng-template #popoverContent>
      <span i18n>You can do an advanced search like</span><br /><br />
      <strong>a</strong> and <strong>b</strong> and <strong>c</strong><br />
      (<strong>a</strong> or <strong>b</strong>) and not (<strong>c</strong> or <strong>d</strong>)<br />
      ((<strong>a</strong> and <strong>b</strong>) or (<strong>c</strong> and <strong>d</strong>)) and <strong>e</strong>
    </ng-template>
  }
</div>
